var _defs, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5B4FC",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#6366F1",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.8,
    fill: "#312E81",
    filter: "url(#a)",
    cx: 28,
    cy: 28,
    r: 12
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9 110.125 -74.297)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.236 17.839 14.206.249A.647.647 0 0 0 13.682 0v28c.13 0 .261-.04.374-.118l13.03-9.121a.653.653 0 0 0 .15-.922Z",
    fillOpacity: 0.72,
    fill: "#A5B4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.158.249.128 17.839a.651.651 0 0 0 .15.922l13.03 9.122a.66.66 0 0 0 .374.117V0c-.2 0-.4.083-.524.249Z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.32,
    fill: "#38BDF8",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#c)",
    cx: 13.012,
    cy: 13.844,
    r: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon02);
export default __webpack_public_path__ + "static/media/features-icon-02.7d2cdd660bd2e02e5bf7c4004abf89a5.svg";
export { ForwardRef as ReactComponent };